export default __webpack_public_path__ + "static/media/deleteNew.85d29d0e.svg";